import React, { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import { useDispatch } from 'react-redux';
import { getAuthToken, setAuthToken, setRefreshToken } from '../providers/authTokenProvider';
import { cookieLogin } from '../redux/modules/authentication';
const CookieLoginContainer = ({ children }) => {
    const dispatch = useDispatch();
    const [checked, setChecked] = useState(false);
    const [cookies] = useCookies(['access-token', 'refresh-token']);
    useEffect(() => {
        if (!checked) {
            if (cookies['access-token'] && getAuthToken() !== cookies['access-token']) {
                const payload = { accessToken: cookies['access-token'] };
                setAuthToken(cookies['access-token']);
                if (cookies['refresh-token']) {
                    payload.refreshToken = cookies['refresh-token'];
                    setRefreshToken(cookies['refresh-token']);
                }
                dispatch(cookieLogin(payload));
            }
            setChecked(true);
        }
    }, [checked]);
    if (checked) {
        return React.createElement(React.Fragment, null, children);
    }
    return null;
};
export default CookieLoginContainer;
